<div class="modal-header">
    <h4 class="modal-title">Registrar producto</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    modal
</div>
